import React from 'react';
import moment from 'moment';
import { useAsync, useAsyncCallback } from 'react-async-hook';
// @ts-ignore
import { Confirm } from 'react-confirm-bootstrap';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Alert, MenuItem, SplitButton } from 'react-bootstrap/lib';
import { TranslationRules as TranslationRulesType } from '@upstart/harmony/lib/legos/translationRulesTypes';
import {
  BootstrapTable,
  Options,
  TableHeaderColumn,
} from 'react-bootstrap-table';
import SidebarContainer from '../SidebarContainer';
import TranslationRulesService from '../../services/TranslationRulesService';

const TABLE_OPTIONS: Options = {
  defaultSortName: 'name',
  defaultSortOrder: 'asc',
  insertBtn: () => (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/translationRule/' }}
    >
      Add New
    </Link>
  ),
};
const TABLE_STYLES = {
  border: 'none',
};

function TranslationRules(props: RouteComponentProps<{}>) {
  const deleteTranslationRules = useAsyncCallback(
    TranslationRulesService.delete,
  );
  const allTranslationRules = useAsync<TranslationRulesType[]>(
    TranslationRulesService.getAll,
    [],
  );

  const ActionsCell = React.useCallback(
    (cell, translationRules) => (
      <SplitButton
        title="Edit"
        key={translationRules.id}
        id={`split-button-basic-group-${translationRules.id}`}
        onClick={() => {
          props.history.push(`/translationRule/${translationRules.id}`);
        }}
      >
        <Confirm
          onConfirm={() => {
            // Delete translation rules object with the given id
            deleteTranslationRules.execute(translationRules.id).then(() => {
              // Fetch the list
              allTranslationRules.execute();
            });
          }}
          body={`Are you sure you want to remove ${translationRules.name}?`}
          confirmText="Confirm Delete"
          title={`Deleting ${translationRules.name}`}
        >
          <MenuItem>Delete</MenuItem>
        </Confirm>
      </SplitButton>
    ),
    [deleteTranslationRules, allTranslationRules],
  );

  return (
    <SidebarContainer title="Translations" openSubMenu="Client Management">
      <div className="dealers-table">
        <div className="dealer-list-container">
          {allTranslationRules.loading ? (
            <Alert>Loading...</Alert>
          ) : (
            <BootstrapTable
              data={allTranslationRules.result ?? []}
              hover
              striped
              pagination
              insertRow
              bodyContainerClass="list-body-container"
              tableStyle={TABLE_STYLES}
              options={TABLE_OPTIONS}
            >
              <TableHeaderColumn dataField="id" isKey>
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="name"
                dataSort
                filter={{ type: 'TextFilter', defaultValue: '' }}
              >
                Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataFormat={(cell, translationRules) =>
                  translationRules?.publishedAt
                    ? moment(translationRules.publishedAt).format('llll')
                    : 'N/A'
                }
              >
                Last Published At
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="button"
                columnClassName="list-action-column"
                dataFormat={ActionsCell}
              />
            </BootstrapTable>
          )}
        </div>
      </div>
    </SidebarContainer>
  );
}

export default TranslationRules;
